module.exports = __webpack_public_path__ + "assets/img/excel.65fa24f9.png";